import { Component } from 'react';

class GopayInline extends Component {

	script = null;

	componentDidMount () {
		this.script = document.createElement('script');
		this.script.src = this.props.src;
		document.body.appendChild(this.script);
	}

	componentWillUnmount() {
		if (this.script !== null) {
			document.body.removeChild(this.script);
		}
	}

	render() {
		return null;
	}
}

export default GopayInline;



// WEBPACK FOOTER //
// ./src/components/GopayInline.jsx